module.exports = __webpack_public_path__ + "static/media/pay-with-card.654785b1.svg";